import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import "./dashboard.scss";
import logo from "../../../assets/support.png";
import DashNavbar from "../DashNavbar";
import Loader from "../../../components/Loader/Loader";
import MobSupport from "./SupportMob/MobSupport";

function Support() {
  const [loading, setLoading] = useState(false);

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };
  const navigate = useNavigate();

  return (
    // <div className="dashMain">
    //   <div className="sideBar">
    //     <Sidebar />
    //   </div>
    //   {hideSvg ? (
    //     <div className="sideBarMobile">
    //       <Sidebar />
    //     </div>
    //   ) : (
    //     <div></div>
    //   )}
    //   <div className="content">
    //     <div className="user">
    //       <div className="svgMain" onClick={handleSvg}>
    //         {hideSvg ? (
    //           <div className="closeSvg"></div>
    //         ) : (
    //           <div className="hamburgerSvg">
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="24"
    //               height="24"
    //               viewBox="0 0 24 24"
    //               fill="#0F0223"
    //               stroke="#eee2e2"
    //               stroke-width="2"
    //               stroke-linecap="round"
    //               stroke-linejoin="round"
    //               class="lucide lucide-menu"
    //             >
    //               <line x1="4" x2="20" y1="12" y2="12" />
    //               <line x1="4" x2="20" y1="6" y2="6" />
    //               <line x1="4" x2="20" y1="18" y2="18" />
    //             </svg>
    //           </div>
    //         )}
    //       </div>

    //       <div className="userSec">
    //         {hideSvg ? (
    //           <div onClick={handleSvg}>
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="24"
    //               height="24"
    //               viewBox="0 0 24 24"
    //               fill="#0F0223"
    //               stroke="#eee2e2"
    //               stroke-width="2"
    //               stroke-linecap="round"
    //               stroke-linejoin="round"
    //               class="lucide lucide-x-square"
    //             >
    //               <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
    //               <path d="m15 9-6 6" />
    //               <path d="m9 9 6 6" />
    //             </svg>
    //           </div>
    //         ) : (
    //           <>
    //             <DashNavbar />
    //           </>
    //         )}
    //       </div>
    //     </div>

    //   </div>
    // </div>
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="header-container-support">
            <span className="back-icon" onClick={() => navigate(-1)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#FFB000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </span>
            <h2 className="section-title">SUPPORT</h2>
          </div>
          <div className="suppMain">
            <div>
              <div className="supportImg">
                <img src={logo} alt="" />
              </div>
              <div className="dashHeaderMain">
                <p className="dashHeaderTag">
                  Need help? Don't sweat it! Just email us at
                  <a
                    className="contactMail"
                    href="mailto:contact@ballerslife.co"
                  >
                    contact@ballerslife.co
                  </a>
                  and we'll sort you out!
                </p>
              </div>
            </div>
          </div>{" "}
          <MobSupport />
        </>
      )}
    </>
  );
}

export default Support;
